import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const PhoneColumn = ({ customerId }) => {
  const [customer] = useSelector((state) => Global.selectEntitiesCustomersByIds(state, { customerIds: [customerId] })) ?? [];

  const { address = {} } = customer || {};
  const phone = (address && address.phone) || '';

  return phone;
};

export const Phone = {
  getMessageDescriptor: () => messages.phone,
  id: 'phone',

  render: ({ customerId }) => {
    return <PhoneColumn customerId={customerId} />;
  },
};
